export const REGULAR_USER = {
  id: "regular-user",
  name: "regularUser",
  label: "Regular User"
};
export const ADMIN = {
  id: "admin",
  name: "admin",
  label: "Admin"
};
export const SUPER_ADMIN = {
  id: "super-admin",
  name: "superAdmin",
  label: "Super Admin"
};
export const ROLES = [REGULAR_USER, ADMIN, SUPER_ADMIN];
